import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { useAppDispatch } from '@reduxStore';
import { queueModal } from '@components/Modals/modalSlice';
import { useMemo } from 'react';

/**
 * Manage Pickup/Delivery Action List Item that opens the Pickup/Delivery modal
 */
export default function ManagePickupDeliveryAction() {
	const gridApiRef = useGridApiContext();
	const appDispatch = useAppDispatch();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const leg = useMemo(() => {
		const legId = selectedRowIds.keys().next().value;
		return legId ? gridApiRef.current.getRow<DispatchLeg>(legId) : undefined;
	}, [gridApiRef, selectedRowIds]);

	// This action requires exactly 1 row to be selected
	if (selectedRowIds.size !== 1 || !leg) {
		return <></>;
	}

	const handleBtnClick = () => {
		appDispatch(
			queueModal({
				Component: 'managePudlModal',
				Props: {
					legId: leg.legId,
					driverId: leg.drvId
				}
			})
		);
	};

	return <ListItemButton onClick={handleBtnClick}>Manage Order + Driver</ListItemButton>;
}
